export default {
  onLine: true,
  wsIsConnected: false,
};
